var _defs, _g, _g2, _g3, _text, _text2, _rect, _path, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXcc: "http://creativecommons.org/ns#",
    xmlnsXdc: "http://purl.org/dc/elements/1.1/",
    xmlnsXrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask3961",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    ry: 71.875,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4097",
    x1: 511.68,
    x2: 511.68,
    y1: 28.688,
    y2: 1697.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1b4488",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1b4488",
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "#fff",
    mask: "url(#mask3961)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3961)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "url(#linearGradient4097)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 724,
    width: 1024,
    height: 300,
    fill: "#6c7d96"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(11.889 25.328)",
    cx: 597.28,
    cy: 132.07,
    rx: 104.89,
    ry: 87.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.06 280.76 454.35 153.26-25 29.348-488.04-96.739z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.45 585.66 360.83-100.5 136.29-1.1188 44.703 48.11 114.48 172.53h-53.415l-113.4-138.97-118.84-2.24-249.68 141.21h-200.52z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 722,
    width: 1030.9,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875 438.06 25 9.375-251.56 303.12-34.38-1.56z",
    fillRule: "evenodd"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 4.8125,
    y: 939.00323,
    fill: "#ffffff",
    fontFamily: "Century",
    fontSize: "185px",
    fontStyle: "italic",
    fontWeight: "bold",
    letterSpacing: "0px",
    wordSpacing: "0px",
    "line-height": "125%",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.8125,
    y: 939.00323
  }, "Crew"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 554.62231,
    y: 939.66199,
    fill: "#ffffff",
    fontFamily: "Century",
    fontSize: "185px",
    fontStyle: "italic",
    fontWeight: "bold",
    letterSpacing: "0px",
    wordSpacing: "0px",
    "line-height": "125%",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 554.62231,
    y: 939.66199
  }, "imer"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 433.94,
    y: 802,
    width: 262,
    height: 24,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m589.06 822.44-137.5 162.5-36.375 1.5625 137.5-164.06z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.25 211.52)",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m301.95-211.52h319.59c101.42 0 152.12 0 206.71 17.26 59.597 21.692 106.54 68.639 128.24 128.24 17.26 54.579 17.26 105.29 17.26 206.7v319.59c0 101.42 0 152.12-17.26 206.71-21.692 59.598-68.639 106.54-128.24 128.24-54.585 17.26-105.29 17.26-206.71 17.26h-319.59c-101.42 0-152.12 0-206.71-17.26-59.591-21.69-106.54-68.64-128.23-128.24-17.26-54.58-17.26-105.29-17.26-206.71v-319.59c0-101.42 0-152.12 17.26-206.71 21.692-59.598 68.639-106.54 128.24-128.24 54.585-17.26 105.29-17.26 206.71-17.26",
    fill: "none",
    stroke: "#000"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    display: "none",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.035156 708.41c0.055642 38.758 0.61632 71.022 3.4892 100.19 0.87578 8.8904 2.0231 17.507 3.3647 25.913 2.7292 17.101 6.2516 30.632 10.625 44.629 0.9831 3.1466 2.3439 6.0091 3.5468 8.8984 4.9544 11.9 10.442 22.625 16.752 32.231 7.4824 11.39 16.591 23.442 26.69 33.796 11.282 11.566 22.163 20.606 34.238 28.786 7.7539 5.2523 15.168 9.8098 23.655 13.919 3.3433 1.6187 6.7835 3.2575 10.455 4.8747 6.0106 2.6472 12.647 5.2405 20.382 7.4312 16.339 4.6274 37.836 9.5058 66.674 11.786 26.049 2.0596 58.072 3.2184 99.208 3.1754h-319.08z",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024 708.38c-0.028 33.525-0.3641 57.519-2.1872 86.13-2.1429 33.631-7.6767 62.031-16.131 85.827-5.1582 14.519-11.404 27.324-18.63 38.558-10.393 16.158-22.651 31.168-36.895 44.464-6.8645 6.4078-13.969 11.816-21.919 17.502-10.374 7.4196-20.225 13.062-32.182 18.638-10.69 4.9858-23.165 9.4996-39.906 13.451-11.585 2.7344-25.212 5.3376-41.704 7.0737-27.233 2.8667-62.178 3.4121-108.26 3.9801h317.81z",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024 318.26c0.1837-39.141-0.2997-73.559-3.476-103.94-1.4113-13.5-3.8539-26.31-5.9548-38.188-3.6187-20.458-10.117-38.447-17.297-52.709-2.1275-4.2261-3.9073-7.5546-5.7778-10.817-1.4979-2.6122-3.054-5.1818-4.8935-8.1356-1.9604-3.1479-3.8735-6.1959-5.993-9.1971-5.73-8.027-12.21-15.91-18.95-23.177-10.07-10.841-21.26-20.982-33.89-29.385-18.04-12.004-33.3-21.308-61.68-29.083-12.9-3.534-28.69-6.869-48.66-9.2268-27.34-3.2267-62.77-4.3075-111.24-4.3882h317.81z",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 318.48c0.044384-54.27 1.9515-103.05 8.7982-140.02 5.9568-32.17 15.843-54.48 29.092-75.08 15.401-23.945 35.125-45.185 59.36-61.349 14.55-9.707 27.24-16.721 46.14-23.976 9.86-3.784 21.35-6.586 34.7-9.1823 30.23-5.8814 72.61-9.1653 140.99-8.8727h-319.08z",
    color: "#000000",
    display: "inline"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2.2054)",
    display: "none",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.99802 321.04v386.28",
    color: "#000000",
    display: "inline",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(1.9888 0 0 1.9885 -407.91 -80.586)",
    cx: 462.32,
    cy: 298.86,
    r: 138,
    color: "#000000",
    display: "inline",
    strokeWidth: 1.0057
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(3.2215 0 0 3.2212 -977.39 -448.56)",
    cx: 462.32,
    cy: 298.86,
    r: 138,
    color: "#000000",
    display: "inline",
    strokeWidth: 0.62086
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.352 69.49 889.21 889.22",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.99801 707.31h1022",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.99801 513.69h1022",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.99801 321.04h1022",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.08 1026.2v-1024",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.68 2.2054v1024",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m706.19 1026.2v-1024",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.352 958.71 889.21-889.22",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m956.56 69.49v889.22",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.352 69.49h889.21",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.352 958.71v-889.22",
    color: "#000000",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m956.56 958.71-889.21-3e-5",
    color: "#000000",
    display: "inline"
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(1.4026 0 0 1.3964 -135.8 96.57)",
    cx: 462.32,
    cy: 298.86,
    r: 138,
    color: "#000000",
    display: "inline",
    strokeWidth: 1.4291
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4ccd3d01842dbd5c1245f94e17b2f8a8.svg";
export { ForwardRef as ReactComponent };